var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 30",
    width: 12,
    height: 12,
    rx: 1,
    transform: "translate(12 12)",
    fill: "#ef5323"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 74",
    d: "M24 17.25h-3.376L19.5 18.9l-3-4.5-1.874 2.85H12v1.5h3.375L16.5 17.1l3 4.5 1.875-2.849H24z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75",
    d: "M18 21a3 3 0 013-3h10a2.966 2.966 0 011 .184V13a1 1 0 00-1-1H20.5l-3-3H9a1 1 0 00-1 1v14a3 3 0 003 3h7z",
    fill: "#444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.9ce60136c0da44bc9d7475e661aee72f.svg";
export { ForwardRef as ReactComponent };